<template>
    <div class="info-wrapper">
        <div class="info">
            <div class="details">
                <div class="avatar">
                    <img :src="accountInfo.headPortraitPath" alt="avatar" >
                    <span class="v-logo">
                        <i :class="['iconfont', ' icon-zhuanjia21', `col-level-${accountInfo.enjoyType}`]" />
                    </span>
                </div>
                <div class="details-item">
                    <div class="info-user">
                        <span :title="accountInfo.name">{{ accountInfo.name | cutText(10) }}</span>
                        <a-tag
                            class="user-identity"
                            :class="{
                                'user-level-1': accountInfo.currentMember && accountInfo.currentMember.memberType === 0,
                                'user-level-2': accountInfo.currentMember && accountInfo.currentMember.memberType === 1,
                                'user-level-3': accountInfo.currentMember && accountInfo.currentMember.memberType === 2,
                            }"
                        >
                            {{ typeText(accountInfo.currentMember) }}
                        </a-tag>
                    </div>
                    <div class="info-topic">
                        <a-tag
                            class="label-item"
                            v-for="(tag, index) in accountInfo.lstRelationTopic"
                            :key="index"
                            @click="goTopicPage(tag.topicId)"
                        >
                            {{ tag.topicName }}
                        </a-tag>
                    </div>
                </div>
            </div>
            <div class="export-attr">
                <div class="total-item">
                    <div class="total-num text-overflow">
                        {{ (trend.attentionNum || 0) | toWan }}
                    </div>
                    <div class="total-text text-overflow">
                        关注者
                    </div>
                    <div class="total-range text-overflow">
                        累计
                    </div>
                </div>
                <div class="total-item">
                    <div class="total-num text-overflow">
                        {{ (trend.praise || 0) | toWan }}
                    </div>
                    <div class="total-text text-overflow">
                        点赞数
                    </div>
                    <div class="total-range text-overflow">
                        累计
                    </div>
                </div>
                <div class="total-item">
                    <div class="total-num text-overflow">
                        {{ (trend.read || 0) | toWan }}
                    </div>
                    <div class="total-text text-overflow">
                        人气值
                    </div>
                    <div class="total-range text-overflow">
                        累计
                    </div>
                </div>
                <div class="total-item">
                    <div class="total-num text-overflow">
                        {{ (trend.rewardCoin || 0) | numDevide100 }}
                    </div>
                    <div class="total-text text-overflow">
                        收益
                    </div>
                    <div class="total-range text-overflow">
                        累计
                    </div>
                </div>
            </div>
        </div>
        <div class="intro">
            <span class="fw">我的简介：</span><span>{{ accountInfo.desc || '-' }}</span>
        </div>
    </div>
</template>
<script>
    import { teamInfo, teamTrend } from '@/store/api/share/creation';

    export default {
        props: {
            shareID: {
                type: String,
                default: '',
            },
            accountInfo: {
                type: Object,
                default: () => ({}),
            },
            trend: {
                type: Object,
                default: () => ({}),
            },
        },
        methods: {
            typeText(obj) {
                if (!obj) return '';
                if (obj) {
                    return ['总管理员', '管理员', '成员'][obj.memberType] || '';
                }
                return '';
            },
            goTopicPage(id) {
                this.$safeOpen(`#/share-study/topic-list?id=${id}`, '_blank');
            },
            // 纷享号信息
            async getTeamInfo() {
                const { data } = await teamInfo({ id: this.sharerID });
                this.accountInfo = data;
            },
            // 统计数据
            async getTrend() {
                const { data } = await teamTrend({ id: this.sharerID });
                this.trend = data;
            },
        },
    };
</script>
<style lang="less" scoped>
.label-item {
    background: #f1f3f4;
    border-radius: 13px;
    color: #768b95;
    border: none;
    cursor: pointer;
    margin: 6px 10px;
    padding: 2px 10px;
}
.user-identity {
    padding: 0 8px;
    border-radius: 13px;
    margin-left: 12px;
    border: none;
    vertical-align: text-bottom;
    margin-bottom: 1px;
}

.user-level-1 {
    background: #f8eeee;
    color: #cb2a2a;
}
.user-level-2 {
    background: #fff0c8;
    color: #fa8b14;
}
.user-level-3 {
    background: #c9e5ff;
    color: #00aeff;
}
.info-wrapper {
    background-color: #fff;
    padding: 20px;
    overflow: hidden;
    height: 100%;
    border-radius: 0 0 6px 6px;
    margin-bottom: 15px;
    .info {
        overflow: hidden;
        padding: 0 0 14px;
        border-bottom: 1px #dedede solid;
        .details,
        .export-attr {
            overflow: hidden;
            float: left;
        }
        .details {
            width: 55%;
            .avatar,
            .details-item {
                float: left;
                text-align: left;
            }
            .avatar {
                position: relative;
                height: 60px;
                width: 60px;
                border-radius: 50%;
                margin-right: 15px;
                background: #eeeeee;
                margin-top: 6px;
                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
                .v-logo {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    background: #fff;
                    height: 14px;
                    width: 14px;
                    .iconfont {
                        position: absolute;
                        height: 14px;
                        width: 14px;
                        top: -4px;
                    }
                }
            }
            .details-item {
                width: calc(100% - 85px);
                box-sizing: border-box;
                .info-user {
                    padding-left: 8px;
                    font-size: 22px;
                    font-weight: 600;
                    height: 35px;
                    line-height: 35px;
                }
            }
        }
        .export-attr {
            width: 45%;
            max-height: 90px;
            .total-item:hover {
                cursor: pointer;
            }
            .total-item:nth-child(n) {
                &::after {
                    position: absolute;
                    content: '';
                    height: 33px;
                    width: 1px;
                    background: #dddddd;
                    display: block;
                    right: 0;
                    top: 24px;
                }
            }
            .total-item:last-child {
                &::after {
                    display: none;
                }
            }
            .total-item {
                width: 25%;
                float: left;
                text-align: center;
                position: relative;
                .total-num {
                    color: #387490;
                    font-size: 20px;
                    font-weight: 500;
                }
                .total-text {
                    font-size: 12px;
                    margin: 5px 0;
                }
                .total-range {
                    color: #888888;
                    font-size: 12px;
                }
            }
        }
    }
    .intro {
        margin-top: 12px;
        text-align: left;
    }
    .export-attr {
        width: 45%;
        max-height: 90px;
        .total-item:hover {
            cursor: pointer;
        }
        .total-item:nth-child(n + 2) {
            &::after {
                position: absolute;
                content: '';
                height: 33px;
                width: 1px;
                background: #dddddd;
                display: block;
                right: 0;
                top: 24px;
            }
        }
        .total-item {
            width: 25%;
            float: right;
            text-align: center;
            position: relative;
            .total-num {
                color: #387490;
                font-size: 20px;
                font-weight: 500;
            }
            .total-text {
                font-size: 12px;
                margin: 5px 0;
            }
            .total-range {
                color: #888888;
                font-size: 12px;
            }
        }
    }
}
</style>
